<template>
  <div>
    <div v-if="!itemId">
      <v-card class="ma-2 pa-3 blueCard" flat :loading="loading">
        <div
          class="d-flex flex-row flex-wrap align-start justify-space-between title"
        >
          <div>Ads Admin</div>
          <v-btn
            rounded
            small
            depressed
            class="mx-3"
            :to="{ path: '/boss/ads/new' }"
            ><v-icon small color="green">mdi-plus-circle</v-icon>Add ad</v-btn
          >
        </div>
        <div class="">
          <div class="d-flex flex-row">
            <v-checkbox
              v-model="onlyActive"
              label="Only show currently active ads"
              hide-details="auto"
            ></v-checkbox>
          </div>
        </div>
      </v-card>
      <generic-admin-list
        title="Ads"
        :headers="headers"
        :data="processedAdList"
        displayField="published"
        itemsKey="items"
        editPath="/boss/ads"
        actionField="name"
        class="my-2"
        sortBy="starts"
        :sortDesc="true"
      ></generic-admin-list>
    </div>

    <edit-ad
      v-else
      :itemId="itemId"
      :companies="allCompanies"
      class="my-2"
      @cancel="itemid = null"
    >
      <!-- @edited="itemEdited()" -->
    </edit-ad>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import GenericAdminList from "@/components/adminStuff/GenericAdminList";
import EditAd from "./EditAd";

export default {
  name: "AdsAdminHome",
  components: {
    GenericAdminList,
    EditAd,
    //  FileBrowser
  },
  props: {},
  data: function () {
    return {
      adList: null,
      loading: false,
      onlyActive: false,
      itemId: null,
      theFile: null,
      openFileBrowser: false, // temporary
      headers: [
        { value: "id", text: "Id" },
        { value: "name", text: "Name" },
        { value: "company", text: "Company" },
        // { value: "url", text: "URL" },
        { value: "published", text: "Published" },
        { value: "clicks", text: "Clicks" },
        { value: "views", text: "Views" },
        { value: "status", text: "Status" },
        { value: "starts", text: "Starts" },
        { value: "expires", text: "Expires" },
      ],
    };
  },
  methods: {
    getAds() {
      this.loading = true;
      // ApiServices.getAds("admin=1")
      ApiServices.genericApiCall("/ads/getAds?admin=1")
        .then((response) => {
          this.adList = response.data.items;
        })
        .catch((error) => {
          console.log(error);
          this.adList = null;
          this.error = "An API error occurred";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDate(dateString) {
      // eg 2022-01-07
      let parts = dateString.split("-");
      let date = new Date(parts[0], parts[1] - 1, parts[2]); // Note: months are 0-based
      return date.setHours(0, 0, 0, 0);
    },
    isDateBeforeToday(date) {
      if (!date) return true;
      let x = this.getDate(date) <= new Date().setHours(0, 0, 0, 0);
      //   console.log("before?", date, x);
      return x;
    },
  },
  computed: {
    processedAdList: function () {
      if (!this.adList) return null;
      let rtn = [];
      this.adList.forEach((row) => {
        let start = row.starts;
        let exp = row.expires; // may be null - if so, consider not expired
        let hasStarted = this.isDateBeforeToday(start);
        let hasExpired = exp && this.isDateBeforeToday(exp);

        let status = null;
        if (hasStarted && !hasExpired) {
          status = "Active";
        } else if (hasExpired) {
          status = "Expired";
        } else if (!hasStarted) status = "Scheduled";

        row.status = status;
        if (status == "Active" || !this.onlyActive) rtn.push(row);
      });
      return rtn;
    },
    allCompanies: function () {
      if (!this.adList) return null;
      let companies = [];
      this.adList.forEach((row) => {
        let company = row.company;
        if (!companies.includes(company)) companies.push(company);
      });
      return companies;
    },
  },
  mounted() {
    this.getAds();
    this.itemId = this.$route?.params?.item ? this.$route.params.item : null;
    // this.getList();
  },
};
</script>

<style scoped></style>
